export const formatCartQuantity = (itemsInCart: number): string =>
    itemsInCart > 99 ? "99+" : `${itemsInCart}`;
